import { HttpParams } from "@angular/common/http";
import { otherQueryParams, QueryParams } from "src/app/interfaces/query";

export function parseQueryParams(
  params?: QueryParams,
  defaultOrder?: string,
  otherParams?: otherQueryParams,
  considerWhereParamsIfWhereOtherParamsExist: boolean = false
): HttpParams {
  if (params) {
    const { pageIndex, pageSize, sortField, sortOrder, where } = params;
    const limit = pageSize;
    const offset = pageSize * (pageIndex - 1);

    const order =
      sortOrder !== null
        ? sortOrder === "ascend"
          ? "ASC"
          : "DESC"
        : defaultOrder || null;
    const orderBy = sortField;

    let _params = new HttpParams()
      .append("limit", limit)
      .append("offset", offset);

    if (order) _params = _params.append("order", order);
    if (orderBy) _params = _params.append("order_by", orderBy);
    if (where) _params = _params.append("where", JSON.stringify(where));

    if (otherParams) {
      for (const [key, value] of Object.entries(otherParams)) {
        if (
          considerWhereParamsIfWhereOtherParamsExist &&
          key == "where" &&
          where &&
          value
        ) {
          _params.append(
            "where",
            JSON.stringify([...where, ...JSON.parse(value)])
          );
        } else {
          _params = _params.append(key, value);
        }
      }
    }
    return _params;
  } else return new HttpParams();
}
